import { render, staticRenderFns } from "./signDetails.vue?vue&type=template&id=337baa80&scoped=true&"
import script from "./signDetails.vue?vue&type=script&lang=js&"
export * from "./signDetails.vue?vue&type=script&lang=js&"
import style0 from "./signDetails.vue?vue&type=style&index=0&id=337baa80&lang=less&"
import style1 from "./signDetails.vue?vue&type=style&index=1&id=337baa80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337baa80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337baa80')) {
      api.createRecord('337baa80', component.options)
    } else {
      api.reload('337baa80', component.options)
    }
    module.hot.accept("./signDetails.vue?vue&type=template&id=337baa80&scoped=true&", function () {
      api.rerender('337baa80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/signDetails.vue"
export default component.exports